import React, { useEffect, useState } from 'react';
import AppModal from '@app/react/components/AppModal/AppModal.jsx';
import RegistrationForm from './RegistrationForm.jsx';
import './styles.scss';

export default function RegistrationModal() {
  const [show, setShow] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const triggers = document.querySelectorAll('[data-open-registration-modal]');
    const open = () => { setShow(true); setSuccess(false); };
    triggers.forEach(el => el.addEventListener('click', open));
    return () => triggers.forEach(el => el.removeEventListener('click', open));
  }, []);

  function handleSuccess(cancelled = false) {
    if (cancelled) {
      setShow(false);
      return;
    }
    setSuccess(true);
    setTimeout(() => setShow(false), 5000);
  }

  return (
    <AppModal
      show={show}
      onHide={() => setShow(false)}
      title={success ? Drupal.tt("richiesta inviata") : Drupal.tt("invia richiesta di accesso")}
      size={success ? undefined : "xl"}
      closeOnBackdropClick={false}
      showCloseButton={!success}
    >
      {success ? (<>
        <p>{Drupal.tt('grazie per la tua richiesta! presto riceverai una email con un link per il primo accesso.')}</p>

        <div className="d-flex justify-content-end mt-4">
          <button className="btn btn-primary" onClick={() => setShow(false)}>{Drupal.tt('visita diemmebi')}</button>
        </div>
      </>) : (
        <RegistrationForm onSuccess={handleSuccess} />
      )}
    </AppModal>
  );
}
